/*global window, _, MOVE_DATA, localStorage, JST */

let isEmpty;

// warning -- formatPrice("7510.07") === "7510.7"
export const formatPrice = function formatPrice(value) {
  if(!value) { return 0; }
  return value.replace(/^.*\$(0)0*$|.*\$0*|,/gm, "$1").replace(/0*([1-9][0-9]*|0)/gm, "$1");
};

export const formatPercent = function formatPercent(value) {
  if(!value) { return 0; }
  return value.replace(/[\.]+/g, '.').replace(/\%/g, '');
};

export const commaDelimit = function commaDelimit(value) {
  if(!value) { return "0"; }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatPriceToNumber = function formatPriceToNumber(value) {
  return value.replace(/^.*\$(0)0*$|.*\$0*|,/gm, "$1");
};

export const truncateAgentDescription = function truncateAgentDescription(text) {
  if (text && text.length > 205) {
    return text.substr(0, text.lastIndexOf(' ', 202)) + ' ...';
  } else {
    return text;
  }
}

/**
 * Abbreviates large numbers to short thousands/million format 10k.. 1.2M etc.
 *
 * @method abbreviateCurrency
 * @param {number} value
 * @return {string} short version of number
 */
export const abbreviateCurrency = function abbreviateCurrency(value) {
  value = !isEmpty(value) && value !== "" ? value : 0;
  var result = value.toString(), // coerce to string
      mode = "";
  value = parseInt(value, 10);
  // Calculate abbreviation
  if (value >= 1000 && value < 1000000) {
    value = Math.floor(value / 1000);
    if (value < 1000) {
      mode = "k";
    } else {
      value = Math.floor(value / 1000);
      mode = "M";
    }
  } else if (value >= 1000000) {
    value = Math.floor(value / 1000);
    value = Math.floor(value / 10);
    value = (value / 100).toFixed(2);
    mode = "M";
  }
  // Convert result
  result = value.toString();
  // Suppress last zero digits
  if (result.indexOf(".00") > -1) {
    result = result.substr(0, result.indexOf(".00"));
  }
  // Suppress last empty digit (zero)
  if (result.indexOf('.') > -1 && result.substr(result.length - 1, 1) === "0") {
    result = result.substr(0, result.length - 1);
  }
  result += mode;
  return '$' + result;
};

export const formatMortgagePercent = function formatMortgagePercent(value) {
  var i = 0;
  return value.replace(/[\.\%]/g, function () {
    return i++ === 0 ? '.' : '';
  });
};

/**
 *
 * @param OBJ => Any object with property and values which is to be made constant.
 * @returns {*} => returns object whose properties values cant be modified.
 */
export const constantize = function (OBJ) {
  var C = null;
  for (C in OBJ) {
    Object.defineProperty(OBJ, C, {value: OBJ[C], writable: false});
  }
  return OBJ;
};

//For checking if a string is blank, null or undefined
isEmpty = function isEmpty(str) {
  return (!str || /^\s*$/.test(str));
};

export const getPriceFactor = function (v) {
  if (v < 100) {
    return 10;
  }
  else if (v < 1000) {
    return 100;
  }
  else if (v < 10000) {
    return 1000;
  }
  else if (v < 100000) {
    return 10000;
  }
  else if (v < 150000) {
    return 20000;
  }
  else if (v < 200000) {
    return 30000;
  }
  else if (v < 500000) {
    return 50000;
  }
  else if (v < 1000000) {
    return 100000;
  }
  else if (v < 5000000) {
    return 200000;
  }
  else if (v < 10000000) {
    return 300000;
  }
  else if (v < 100000000) {
    return 10000000;
  }
  else if (v < 1000000000) {
    return 100000000;
  }
  else if (v < 10000000000) {
    return 1000000000;
  }
};

export const roundOffPrice = function (value) {
  var factor = getPriceFactor(value);
  return Math.round(value / factor) * factor;
};

export const arrayEqual = function(arr1, arr2){
  if(arr1.length !== arr2.length) { return false; }
  arr1 = arr1.sort();
  arr2 = arr2.sort();
  for(var i = 0; i < arr1.length; i++){
    if(arr1[i] !== arr2[i]){
      return false;
    }
  }
  return true;
};


export const formatLoanTypes = function(){
  return [
    {'30YrFixed':     '30yr fixed'    },
    {'30YrFixed_FHA': '30yr fixed FHA'},
    {'30YrFixed_VA':  '30yr fixed VA' },
    {'20YrFixed':     '20yr fixed'    },
    {'15YrFixed':     '15yr fixed'    },
    {'10YrFixed':     '10yr fixed'    },
    {'5Arm':          '5/1 ARM'       },
    {'7Arm':          '7/1 ARM'       }
  ]
};

export const homeEquityLoanTypes = [
  {value: 'HELOC,HELOAN_FIXED_5YEARS,HELOAN_FIXED_10YEARS,HELOAN_FIXED_15YEARS,HELOAN_FIXED_20YEARS,HELOAN_FIXED_30YEARS', label: 'All Equity Products' },
  {value: 'HELOC', label: 'Home Equity Line of Credit'  },
  {value: 'HELOAN_FIXED_5YEARS',  label: 'Home Equity Loan - 5 Years'  },
  {value: 'HELOAN_FIXED_10YEARS', label: 'Home Equity Loan - 10 Years' },
  {value: 'HELOAN_FIXED_15YEARS', label: 'Home Equity Loan - 15 Years' },
  {value: 'HELOAN_FIXED_20YEARS', label: 'Home Equity Loan - 20 Years' },
  {value: 'HELOAN_FIXED_30YEARS', label: 'Home Equity Loan - 30 Years' }
];

(function (MOVE) {
  MOVE.FormatHelper = {
    abbreviateCurrency: abbreviateCurrency,
    formatPrice: formatPrice,
    formatPercent: formatPercent,
    commaDelimit: commaDelimit,
    formatPriceToNumber: formatPriceToNumber,
    formatMortgagePercent: formatMortgagePercent,
    formatLoanTypes: formatLoanTypes,
    isEmpty: isEmpty,
    constantize: constantize,
    roundOffPrice: roundOffPrice,
    arrayEqual: arrayEqual,
    truncateAgentDescription: truncateAgentDescription,
    _TEST_getPriceFactor: getPriceFactor
  };

}(MOVE));



// WEBPACK FOOTER //
// ./shared_critical/format_helper.js